import OtherArticlesCard from 'ui/components/molecules/OtherArticlesCard';

interface IOtherArticlesProps {
  categoryGTM?: string;
  handleCollectDataLayer?: (data: {
    id: string;
    name: string;
    creative: string;
    position: string;
  }) => void;
  items?: {
    id: string;
    titlePage: string;
    slug: string;
    contentCategory: {
      name: string;
    };
    tag: {
      tagName: string;
    };
    heroImageLink: string;
    altImage: string;
    publishedDate: string;
  }[];
  classNames?: string;
  enableSharing?: boolean;
  classNameWrapper?: string;
  optimize?: boolean;
}

const OtherArticles = ({
  categoryGTM = '',
  handleCollectDataLayer = () => {},
  items = [],
  classNames = 'h-full border-b border-reliableBlack70 snap-center',
  enableSharing = false,
  classNameWrapper = 'w-full overflow-x-auto snap-x snap-mandatory grid gap-2.5 grid-flow-col no-scrollbar lg:grid-cols-4 lg:gap-6',
  optimize,
}: IOtherArticlesProps) => {
  return (
    <div
      className={classNameWrapper}
      style={{
        gridAutoColumns: `calc(100% / 2 - 0.625rem)`,
      }}
    >
      {items.map((item, idx) => (
        <OtherArticlesCard
          key={idx}
          classNames={classNames}
          handleCollectDataLayer={handleCollectDataLayer}
          data={item}
          enableSharing={enableSharing}
          optimize={optimize}
          categoryGTM={categoryGTM}
          idx={idx}
        />
      ))}
    </div>
  );
};

export default OtherArticles;
